import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/oauth/public/oauth";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/loginModel.js
// module id = 173
// module chunks = 0